<template>
  <!-- Circle: always visible, resizes smoothly via width/height transition. -->
  <div
    class="cursor-circle"
    :class="[`circle-size-${currentState}`, { 'cursor-hidden': isOverIframe || isOutsideWindow }]"
    :style="containerStyle"
  />

  <!-- Hover: arrow only — fades in on top of the circle. -->
  <InlineSvg
    v-if="hoverSvg?.layer1"
    :src="hoverSvg.layer1"
    class="cursor-overlay-icon"
    :class="[{ active: currentState === 'hover' }, { 'cursor-hidden': isOverIframe || isOutsideWindow }]"
    :style="containerStyle"
  />

  <!-- Project: pill SVG — circle collapses, pill takes over. -->
  <InlineSvg
    v-if="projectSvg?.layer1"
    :src="projectSvg.layer1"
    class="cursor-overlay-icon"
    :class="[{ active: currentState === 'project' }, { 'cursor-hidden': isOverIframe || isOutsideWindow }]"
    :style="containerStyle"
  />
</template>

<script>
export default { name: 'CursorLabeled' };
</script>

<script setup>
import { computed } from 'vue';
import InlineSvg from 'vue-inline-svg';
import { useCursorState } from './useCursorState.js';

const { currentState, containerStyle, isOverIframe, isOutsideWindow } = useCursorState();

function getCursorSvg(state) {
  try {
    const plain = require(`../../../../../images/cursors/LABELED/${state}.svg`);
    return { layer1: plain, layer2: null };
  } catch (_) {}
  let layer1 = null, layer2 = null;
  try { layer1 = require(`../../../../../images/cursors/LABELED/${state}_1.svg`); } catch (_) {}
  try { layer2 = require(`../../../../../images/cursors/LABELED/${state}_2.svg`); } catch (_) {}
  if (layer1 || layer2) return { layer1, layer2 };
  return null;
}

const hoverSvg = computed(() => getCursorSvg('hover'));
const projectSvg = computed(() => getCursorSvg('project_hover'));
</script>

<style scoped lang="scss">
@import './cursor-shared';

// Project: circle collapses since the pill takes over.
.cursor-circle.circle-size-project {
  width: 0;
  height: 0;
  transition:
    width  0.12s cubic-bezier(0.3, 0, 1, 1),
    height 0.12s cubic-bezier(0.3, 0, 1, 1);
}


</style>
